import { Tabs } from 'antd'
import { FC } from 'react'
import shallow from 'zustand/shallow'
import { useAuth } from '../../../context/auth-context'
import { getCompanySettingsPermissionInfo } from '../../../shared/permissions/permission-helper'
import { CompanySettingsPermissions } from '../permissions'
import { HrSupportFeedbackTab } from './feedback/HrSupportFeedbackTab'
import { HrSupportHRBPTab } from './hrBusinessPartner/HrSupportHRBPTab'
import { useHrSupportStore } from './HrSupportStore'
import { HrSupportTabs } from './types'
import { HrSupportCountrySettingsTab } from './HrSupportCountrySettingsTab'
import { HrSupportNationalContractReferenceTab } from './nationalContractReference/HrSupportNationalContractReferenceTab'
import { RoleName } from '../../../types'

const { TabPane } = Tabs

export const HrSupportContent: FC = () => {
  const { user } = useAuth()
  const [activeTab] = useHrSupportStore((state) => [state.activeTab], shallow)
  const isHrAdminIta = user.roles?.includes(RoleName.HrAdminIta) || false
  const companySettingsPermissionInfo = getCompanySettingsPermissionInfo(user.roles ? user.roles : [])

  return (
    <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
      {companySettingsPermissionInfo[CompanySettingsPermissions.hrFeedbackTab] && (
        <TabPane key={HrSupportTabs.feedback}>
          <HrSupportFeedbackTab />
        </TabPane>
      )}
      {companySettingsPermissionInfo[CompanySettingsPermissions.hrBusinessPartnersTab] && (
        <TabPane key={HrSupportTabs.hrbusinessPartner}>
          <HrSupportHRBPTab />
        </TabPane>
      )}
      {companySettingsPermissionInfo[CompanySettingsPermissions.hrCountrySettingsTab] && (
        <TabPane key={HrSupportTabs.countrySettings}>
          <HrSupportCountrySettingsTab />
        </TabPane>
      )}
      {isHrAdminIta && companySettingsPermissionInfo[CompanySettingsPermissions.hrNationalContractReferenceTab] && (
        <TabPane key={HrSupportTabs.nationalContractReference}>
          <HrSupportNationalContractReferenceTab />
        </TabPane>
      )}
    </Tabs>
  )
}
